let ElementProps = {
    Object: null,
    Type: 'none',
    Text: 'none',
    Font: 'none',
    FontFamily: 'none',
    FontWeight: 'none',
    FontSize: 'none',
    Color: 'none',
    BColor: 'none',
    Bold: false,
    Italic: false,
    Bound: false,
    Continuous: false,
    Align: 'none',
    CharSpacing: false,
    DataType: 'none',
    Format: 'none',
    SourceFormat: 'none',
    DataSource: 'none',
    binding: null,
    Condition: 'none',
    Calculation: 'none',
    CalculationKey: 'none',
    ConditionKeys: 'none',
    Resource: 'none',
    MLine: false,
    MLineWidth: 'none',
    Jpg: 'none',
    JpgPath: 'none',
    JpgFileName: 'none',
    JpgBlob: 'none',
    JpgOriginalWidth: 'none',
    JpgOriginalHeight: 'none',
    JpgOriginalAspectRatio: 'none',
    CertFileName: 'none',
    CertBlob: 'none',
    CertPath: 'none',
    Password: 'none',
    ContentState: 'none',
    BorderColor: 'none',
    Fill: false,
    FillColor: 'none',
    BorderWidth: 'none',
    BorderStyle: 'none',
    Direction: '0',
    Zindex: 100,
    QREncoding: 2,
    QRVersion: 2,
    QRLevel: 1,
    BarcodeType: "EAN128",
    Thickness: 0,
    QRUnicode: 1
}
export default ElementProps;
